import { createApiActions } from '../../../../utils/api-state';
import { createAction, props } from '@ngrx/store';
import {
  ProfileEmailGetRequest,
  ProfileEmailGetResponse,
  ProfileEmailUpdateRequest,
  ProfileResidenceResponse,
} from '../../models/profile-residence.model';
import { ProfilePaperlessNormalized } from '../../models/profile-paperless.model';

export const getPaperlessActions = createApiActions<number, ProfilePaperlessNormalized>(
  '[Profile] Get Profile Paperless Response'
);

export const getProfileResidenceActions = createAction('[Profile] Get Profile Residence Response');
export const getProfileResidenceClearActions = createAction('[Profile] Clear Profile Residence Response');
export const getProfileResidenceSuccessActions = createAction(
  '[Profile] Get Profile Residence Response Success',
  props<{ data: ProfileResidenceResponse[] }>()
);

export const getProfileResidenceFailureActions = createAction(
  '[Profile] Get Profile Residence Response Failure',
  props<{ error: any }>()
);

export const getProfileEmailActions = createApiActions<ProfileEmailGetRequest, ProfileEmailGetResponse>(
  `[Profile] Get Profile Email`
);
export const updateProfileEmailSuccess = createAction(
  '[Profile] Update Email Success',
  props<{ response: ProfileEmailUpdateRequest }>()
);
